import LAppDefine from "./lappdefine";


export let s_instance: LAppMessageBox = null;
export let messageBox: HTMLDivElement = null;

export class LAppMessageBox {
    public static getInstance(): LAppMessageBox {
        if (s_instance == null) {
            s_instance = new LAppMessageBox();
        }

        return s_instance;
    }

    public getMessageBox(): HTMLDivElement {
        if (this._messageBox == null) {
            this._messageBox = document.querySelector('#'+ LAppDefine.MessageBoxId);
        }
        return this._messageBox;
    }

    public initialize(canvas: HTMLCanvasElement, style: Record<string, any> = {}): boolean {
        messageBox = document.createElement('div');

        messageBox.id = LAppDefine.MessageBoxId;
        messageBox.style.position = 'fixed';
        messageBox.style.padding = '10px';
        messageBox.style.zIndex = '9999';
        messageBox.style.display = 'flex';
        messageBox.style.justifyContent = 'center';

        messageBox.style.width = canvas.width + 'px';
        messageBox.style.height = '20px';
        messageBox.style.right = '0';
        messageBox.style.bottom = canvas.height + 50 + 'px';
        for (let key in style) {
            if (!!key && key != "innerHTML" && key != "innerText") {
                if (messageBox.style.hasOwnProperty(key)) {
                    Reflect.set(messageBox.style, key, Reflect.get(style, key));
                }
            }
        }
        messageBox.innerHTML = '<div class="live2dMessageBox-content"></div>';
        document.body.appendChild(messageBox);

        const cssText = `#${messageBox.id}.live2dMessageBox-content{background-color:#706561;color:white;padding:10px;height:fit-content;border-radius:.7em;word-break:break-all;border-right:1px solid transparent}#${messageBox.id}.live2dMessageBox-content-hidden{opacity:0;transition:all 0.5s ease-in;-moz-transition:all 0.5s ease-in;-webkit-transition:all 0.5s ease-in}#${messageBox.id}.live2dMessageBox-content-visible{opacity:1;transition:all 0.5s ease-out;-moz-transition:all 0.5s ease-out;-webkit-transition:all 0.5s ease-out}`
        if (!document.head.querySelector("#"+messageBox.id + "_css")) {
            const styleEl = document.createElement('style')
            styleEl.id = "#"+messageBox.id + "_css";
            styleEl.innerHTML = cssText;
            document.head.appendChild(styleEl);
        }

        this.hideMessageBox();
        return true;
    }

    public setMessage(message: string, duration: number=null) {
        const messageBox = this.getMessageBox();

        this.hideMessageBox();
        messageBox.textContent = message;

        setTimeout(() => {
            const wrapperDiv: HTMLDivElement = document.querySelector('#' + LAppDefine.MessageBoxId);
            wrapperDiv.style.bottom = (LAppDefine.CanvasSize === 'auto' ? 500: LAppDefine.CanvasSize.height) + messageBox.offsetHeight - 25 + 'px';
        }, 10);

        this.revealMessageBox();
        if (duration != null) {
            setTimeout(() => {
                this.hideMessageBox();
            }, duration);
        }
    }

    // 隐藏对话框
    public hideMessageBox() {
        const messageBox = this.getMessageBox();
        messageBox.classList.remove('live2dMessageBox-content-visible');
        messageBox.classList.add('live2dMessageBox-content-hidden');
    }

    // 展示对话框
    public revealMessageBox() {
        const messageBox = this.getMessageBox();
        messageBox.classList.remove('live2dMessageBox-content-hidden');
        messageBox.classList.add('live2dMessageBox-content-visible');
    }

    _messageBox: HTMLDivElement = null
}